<ion-content>
  <capacitor-google-map id="map" #map></capacitor-google-map>

  <ion-progress-bar
    color="primary"
    value="{{(loading$ | async)! / 100}}"
    buffer="{{(loading$ | async)! / 100}}"
    *ngIf="(loading$ | async)! > 0"
  ></ion-progress-bar>

  <!-- <div class="spinner" *ngIf="(loading$! | async)! > 0">
    <ion-spinner color="primary"></ion-spinner>
    Sensor map loading...
  </div> -->

  <!-- Main menu button. Hidden when accurating -->
  <ion-fab
    vertical="bottom"
    horizontal="end"
    *ngIf="(accurateGroupPositions$ | async) === false && (accurateDevicePosition$ | async) === false"
    activated="true"
    #mainFab
  >
    <ion-fab-button class="not-visible-fab" title="show" disabled="true">
      <ion-icon name="caret-up-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-list side="top" class="main-fab-list">
      <ion-fab-button (mousedown)="openSettings($event)" title="Settings" color="light"><ion-icon name="cog-outline"></ion-icon></ion-fab-button>
      <ion-fab-button (mousedown)="openSearch($event)" title="Search device" color="light"><ion-icon name="search-outline"></ion-icon></ion-fab-button>
      <ion-fab-button (mousedown)="openBind($event)" title="Place device" color="light"><ion-icon name="hammer-outline"></ion-icon></ion-fab-button>
    </ion-fab-list>
  </ion-fab>

  <!-- Settings button. Shows only when accurating -->
  <ion-fab
    vertical="top"
    horizontal="end"
    slot="fixed"
    [ngClass]="[settingsSide === 'start' ? 'margin-right-accurate-settings margin-top-accurate-settings' : '']"
    *ngIf="(accurateGroupPositions$ | async) === true || (accurateDevicePosition$ | async) === true"
    activated="true"
    id="fab"
    #fab
  >
    <ion-fab-button color="primary" class="not-visible-fab" title="" disabled="true">
      <ion-icon name="settings-outline"></ion-icon>
    </ion-fab-button>
    <ion-fab-list [side]="settingsSide">
      <ion-fab-button (mousedown)="myLocation($event)" color="light" title="My position">
        <ion-icon name="navigate-circle-outline"></ion-icon>
      </ion-fab-button>
      <ion-fab-button (mousedown)="openSettings($event)" color="light" title="Settings">
        <ion-icon name="cog-outline"></ion-icon>
      </ion-fab-button>
      <ion-fab-button (mousedown)="openSearchLocation($event)" color="light" title="Search address">
        <ion-icon src="assets/custom-icons/location-icon.svg"></ion-icon>
      </ion-fab-button>
    </ion-fab-list>
  </ion-fab>

  <!-- My location button. Hidden when accurating -->
  <ion-fab
    vertical="top"
    horizontal="end"
    slot="fixed"
    class="margin-top-accurate"
    *ngIf="(accurateGroupPositions$ | async) === false && (accurateDevicePosition$ | async) === false && (loading$ | async) === 0"
  >
    <ion-fab-button (click)="myLocation()" size="small" color="light" [ngClass]="{'native-btn' : native}" title="My position">
      <ion-icon name="navigate-circle-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <!-- Find location button. Hidden when accurating -->
  <ion-fab
    vertical="top"
    horizontal="end"
    slot="fixed"
    class="margin-top-accurate-location"
    *ngIf="(accurateGroupPositions$ | async) === false && (accurateDevicePosition$ | async) === false && (loading$ | async) === 0"
  >
    <ion-fab-button (click)="openSearchLocation()" size="small" color="light" [ngClass]="{'native-btn' : native}" title="Search address">
      <ion-icon src="assets/custom-icons/location-icon.svg"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <!-- Map type button. Hidden when accurating -->
  <ion-fab
    vertical="top"
    horizontal="end"
    slot="fixed"
    class="margin-top-accurate-map-type"
    *ngIf="(accurateGroupPositions$ | async) === false && (accurateDevicePosition$ | async) === false && (loading$ | async) === 0"
  >
    <ion-fab-button (click)="changeMapType()" size="small" color="light" [ngClass]="{'native-btn' : native}" title="Map type">
      <ion-icon name="layers-outline" *ngIf="selectedMapType === mapTypes[1].value"></ion-icon>
      <ion-icon name="layers" *ngIf="selectedMapType === mapTypes[0].value"></ion-icon>
    </ion-fab-button>
  </ion-fab>

  <!-- Select project button. Hidden when accurating -->
  <app-project-select-pane></app-project-select-pane>
</ion-content>

<div class="center-icon" *ngIf="((accurateGroupPositions$ | async) && !(pointsPositions$ | async)?.finish) || (accurateDevicePosition$ | async)">
  <ion-icon name="pin-outline" class="icon" color="warning"></ion-icon>
</div>
